<template>
  <div id="quote" class="quote">
    <div class="list-card">
      <div class="card-title">
        <span>{{ data.startCityName }} > {{ data.storeCode?'#'+data.storeCode+'-' :'' }}  {{ data.destCountryName }}</span>
      </div>
      <div class="card-table">
        <table>
          <tr>
            <td>费用编码</td>
            <td>费用名称</td>
            <td>费用描述</td>
            <td>数量</td>
            <td>单价</td>
            <td>总价</td>
          </tr>
          <tr>
            <td>FBA 运费</td>
            <td>FBA 运费</td>
            <td>FBA 运费</td>
            <td>{{ data.chargeWeight }}</td>
            <td v-if="data.traffic>0">CNY ￥{{ (data.traffic/data.chargeWeight).toFixed(2) }}</td>
            <td v-else>单询</td>
            <td v-if="data.traffic>0">CNY ￥{{ data.traffic }}</td>
            <td v-else>单询</td>
          </tr>
          <tr v-for="feeItem in data.feeList">
            <td>{{ feeItem.feeCode }}</td>
            <td>{{ feeItem.feeNameEn }}</td>
            <td>{{ feeItem.commentEn }}</td>
            <td>{{ feeItem.feeUnit }}</td>
            <td>CNY ￥{{ feeItem.unitPrice }}</td>
            <td>CNY ￥{{ feeItem.totalAmount }}</td>
          </tr>
          <tr v-if="data.startLiftgateAmount>0&&data.traffic>0">
            <td>升降机</td>
            <td>升降机费用</td>
            <td>平台费用</td>
            <td>1</td>
            <td>CNY ￥{{ data.startLiftgateAmount }}</td>
            <td>CNY ￥{{ data.startLiftgateAmount }}</td>
          </tr>
        </table>
      </div>
      <div v-if="data.traffic>0" class="card-subtotal">
        <span>合计: CNY ￥{{ data.subTotal1 }}</span>
      </div>
      <div v-if="data.isCustomsBrokerage&&data.customsFeeList.length>0&&data.traffic>0">
        <div class="card-title">
          <span>目的地报关费用</span>
        </div>
        <div class="card-table">
          <table>
            <tr>
              <td>费用编码</td>
              <td>费用描述</td>
              <td>金额</td>
            </tr>
            <tr v-for="(data,index) in data.customsFeeList" :key="index">
              <td>{{ data.feeNameEn }}
              </td>
              <td>{{ data.commentEn }}</td>
              <td>CNY ￥{{ data.totalAmount }}</td>
            </tr>
            <tr v-if="data.bondAmount>0">
              <td>{{ data.bondType===1?'单次有效bond(货值 USD '+data.totalValue+')':'按年购买bond' }}
              </td>
              <td>-</td>
              <td>CNY ￥{{ data.bondAmount }}</td>
            </tr>
            <tr v-if="data.ISFBondAmount>0">
              <td>ISF Bond</td>
              <td>-</td>
              <td>CNY ￥{{ data.ISFBondAmount }}</td>
            </tr>
          </table>
        </div>
        <div class="card-subtotal">
          <span>合计: CNY ￥{{ data.subTotal2 }}</span>
        </div>
      </div>
      <div v-if="data.buyInsurance==1&&data.traffic>0">
        <div class="card-title">
          <span>保险费</span>
        </div>
        <div class="card-table">
          <table>
            <tr>
              <td>费用编码</td>
              <td>费用描述</td>
              <td>金额</td>
            </tr>
            <tr>
              <td>保险费 (货值 USD {{ data.totalValue }})</td>
              <td>-</td>
              <td>CNY ￥{{ data.insuranceInfo.insuranceAmount }}</td>
            </tr>
          </table>
        </div>
        <div class="card-subtotal">
          <span>合计: CNY ￥{{ data.insuranceInfo.insuranceAmount }}</span>
        </div>
      </div>

      <div class="card-total">
        <span v-if="data.traffic>0">总费用: CNY ￥{{ data.totalAmount }}</span>
        <span v-else>总费用: 单询</span>
      </div>
      <div class="card-remarks">
        <p>服务说明</p>
        <slot v-for="item in data.channelDetail">
          <p>{{ item.moduleName }}:</p>
          <span>
            {{ item.content }}
          </span>
        </slot>

      </div>
    </div>
  </div>
</template>

<script>
import {
  GetFbaOrderDetail
} from '@/api/order.js'
export default {
  name: 'Quote',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      data: {},
      list: []
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    init(data) {
      GetFbaOrderDetail(data.orderNo).then(res => {
        if (res.code === 200) {
          this.data = res.data
		  this.data.subTotal1 = this.data.traffic
		  this.data.feeList.forEach(item => {
			  this.data.subTotal1 += item.totalAmount
		  })
		  this.data.subTotal1 += this.data.startLiftgateAmount
		  this.data.subTotal2 = this.data.bondAmount + this.data.ISFBondAmount
		  this.data.customsFeeList.forEach(item => {
		  			  this.data.subTotal2 += item.totalAmount
		  })
          this.data.totalAmount = (this.data.subTotal1 + this.data.subTotal2 + this.data.insuranceInfo.insuranceAmount).toFixed(3)
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.quote {
		width: 1152px;
		height: auto;
		background: #FFFFFF;
		border-radius: 8px;
		margin-top: 16px;
		padding: 24px;

		.list-card {
			.card-title {
				width: 100%;
				height: 40px;
				background: rgba(170, 170, 170, 0.08);
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				color: #333333;
				line-height: 40px;
				text-align: left;

				span {
					margin-left: 16px;
				}
			}

			.card-table {
				table {
					width: 100%;
					border-collapse: collapse;
					text-align: left;
					padding: 0 8px;

					tr:nth-of-type(1) {
						td {
							font-size: 13px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 550;
							color: #333333;
						}
					}

					tr {
						height: 40px;

						td {
							border-bottom: 1px solid rgba(170, 170, 170, 0.24);
							font-size: 13px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #333333;
							padding: 0 16px;
						}

						td:last-child {
							text-align: right;
						}
					}
				}
			}

			.card-subtotal {
				font-size: 14px;
				font-family: D-DINExp, D-DINExp;
				font-weight: bold;
				color: #333333;
				height: 40px;
				line-height: 40px;
				text-align: right;
				padding-right: 16px;
			}

			.card-total {
				height: 40px;
				line-height: 40px;
				text-align: right;
				background: rgba(2, 127, 252, 0.08);
				font-size: 16px;
				font-family: D-DINExp, D-DINExp;
				font-weight: bold;
				color: #333333;
				padding-right: 16px;
			}

			.card-remarks {
				width: 100%;
				height: 161px;
				background: rgba(0, 0, 0, 0.02);
				border-radius: 8px;
				margin: 16px 0;
				text-align: left;
				overflow-y: scroll;

				p {
					padding: 4px 8px;
					margin: 0;
				}

				span {
					padding: 0 8px;
					display: block;
				}
			}
		}
	}
</style>
